<template>
  <vetster-search-facet-group
    :label="$t('search.language-spoken')"
    group="LANGUAGE"
    :expanded="expanded"
  >
    <div class="relative">
      <div
        v-if="disabled"
        class="
          absolute
          -inset-1
          bg-white
          opacity-75
          text-indigo-600
          font-medium
          text-base
          flex
          items-center
          justify-center
        "
      />
      <label
        v-for="(option, i) in getLanguageOptions"
        :key="i"
        :for="option.value"
        class="flex items-center"
      >
        <input
          :id="option.value"
          v-model="input"
          :value="option.value"
          type="radio"
          class="
            cursor-pointer
            focus:ring-indigo-500
            h-4
            w-4
            text-indigo-600
            border-neutral-300
          "
        />
        <span class="ml-3 block text-sm font-base text-neutral-700 cursor-pointer">
          {{ option.text }}
        </span>
      </label>
    </div>
  </vetster-search-facet-group>
</template>

<script>
import VetsterSearchFacetGroup from '@/components/VetsterSearchFacetGroup';
import useSearchData from '@/composables/use-search-data';

export default {
  name: 'VetsterSearchLanguageInput',

  components: { VetsterSearchFacetGroup },

  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    defaultInput: {
      default: () => [],
      type: Array,
    },
    expanded: {
      default: false,
      type: Boolean,
    },
  },

  setup() {
    const { getLanguageOptions } = useSearchData();

    return { getLanguageOptions };
  },

  computed: {
    input: {
      get() {
        return this.$store.state.search.inputs.language;
      },

      set(value) {
        this.$store.commit('search/setInputs', { language: value });
      },
    },
  },
};
</script>
